var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1A3459"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8189 18.146C33.1363 18.4484 32.4039 18.6536 31.6344 18.7451C32.4201 18.2746 33.0216 17.5283 33.3066 16.6418C32.5696 17.0775 31.756 17.3939 30.8892 17.5654C30.195 16.8249 29.2077 16.3636 28.1125 16.3636C26.0115 16.3636 24.308 18.0672 24.308 20.1671C24.308 20.4649 24.3416 20.7558 24.4065 21.0339C21.2451 20.8751 18.4418 19.3605 16.5656 17.059C16.2376 17.6199 16.051 18.2734 16.051 18.9711C16.051 20.2911 16.7232 21.4557 17.743 22.1371C17.1195 22.1163 16.5331 21.9448 16.0197 21.6597V21.7072C16.0197 23.5498 17.3316 25.0876 19.071 25.4376C18.7523 25.5234 18.4163 25.5709 18.0686 25.5709C17.823 25.5709 17.5854 25.5466 17.3524 25.5002C17.8368 27.0125 19.2414 28.1123 20.9056 28.1424C19.6041 29.1623 17.9632 29.7683 16.1808 29.7683C15.8737 29.7683 15.5713 29.7498 15.2734 29.7162C16.9573 30.7974 18.9563 31.4279 21.1049 31.4279C28.1033 31.4279 31.9288 25.6312 31.9288 20.604L31.916 20.1115C32.6635 19.5783 33.3101 18.9085 33.8189 18.146Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3317_21546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 19,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8189 18.146C33.1363 18.4484 32.4039 18.6536 31.6344 18.7451C32.4201 18.2746 33.0216 17.5283 33.3066 16.6418C32.5696 17.0775 31.756 17.3939 30.8892 17.5654C30.195 16.8249 29.2077 16.3636 28.1125 16.3636C26.0115 16.3636 24.308 18.0672 24.308 20.1671C24.308 20.4649 24.3416 20.7558 24.4065 21.0339C21.2451 20.8751 18.4418 19.3605 16.5656 17.059C16.2376 17.6199 16.051 18.2734 16.051 18.9711C16.051 20.2911 16.7232 21.4557 17.743 22.1371C17.1195 22.1163 16.5331 21.9448 16.0197 21.6597V21.7072C16.0197 23.5498 17.3316 25.0876 19.071 25.4376C18.7523 25.5234 18.4163 25.5709 18.0686 25.5709C17.823 25.5709 17.5854 25.5466 17.3524 25.5002C17.8368 27.0125 19.2414 28.1123 20.9056 28.1424C19.6041 29.1623 17.9632 29.7683 16.1808 29.7683C15.8737 29.7683 15.5713 29.7498 15.2734 29.7162C16.9573 30.7974 18.9563 31.4279 21.1049 31.4279C28.1033 31.4279 31.9288 25.6312 31.9288 20.604L31.916 20.1115C32.6635 19.5783 33.3101 18.9085 33.8189 18.146Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3317_21546)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e786975a671ace1599710ce901fabf99.svg";
export { ForwardRef as ReactComponent };